import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import useRouter from 'utils/useRouter';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider, Button } from '@mui/material';
import { Page, Header } from 'components';
import Details from './components/Details/Details.js';
import History from './components/History/History.js';
import Files from './components/Files/Files.js';
import { GetActivities, GetTicket } from '../../actions/TicketsActions.js';

const tabs = [
	{ value: 'details', label: 'Details' },
	{ value: 'files', label: 'Files' },
	{ value: 'history', label: 'History' },
];

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const TicketDetails = (props) => {
	const classes = useStyles();
	const { match } = props;
	const { params } = match;
	const { id } = params;
	const { history } = useRouter();
	const dispatch = useDispatch();
	const ticket = useSelector((state) => state.ticketsReducer.ticket);
	const [tab, setTab] = useState('details');

	const _back = () => {
		history.goBack();
	};

	const _renderActions = () => (
		<Button variant="outlined" onClick={_back}>
			Back
		</Button>
	);

	useEffect(() => {
		dispatch(GetTicket(id)).then(dispatch(GetActivities(1)));
	}, []);

	const _handleTabsChange = (event, value) => {
		setTab(value);
	};

	if (!tab) {
		return <Redirect to="/home" />;
	}

	if (!tabs.find((t) => t.value === tab)) {
		return <Redirect to="/errors/error-404" />;
	}

	return (
		<Page className={classes.root} title="Tickets">
			<Header module="Tickets" view={`Ticket Details: ${ticket && ticket.details && ticket.details.subject}`} actions={_renderActions()} />
			<Tabs
				className={classes.tabs}
				onChange={_handleTabsChange}
				scrollButtons="auto"
				value={tab}
				variant="scrollable"
			>
				{tabs.map((item) => (
					<Tab key={item.value} label={item.label} value={item.value} />
				))}
			</Tabs>
			<Divider className={classes.divider} />
			<div className={classes.content}>
				{tab === 'details' && <Details ticketId={parseInt(id, 10)} details={ticket && ticket.details} comments={ticket.comments || []} />}
				{tab === 'files' && <Files files={ticket.files || []} />}
				{tab === 'history' && <History history={ticket.history || []} />}
			</div>
		</Page>
	);
};

TicketDetails.propTypes = {
	match: PropTypes.object
};

export default TicketDetails;
